// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__Bf4Rw","icon":"Loader_icon__2o93l","rotateIt":"Loader_rotateIt__zqpzV"};